const subscriber = () => {
    // console.log("this is first subscriber")
}

export default subscriber

